var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0006 1C14.644 1 17.0696 1.9317 18.9661 3.486L17.0718 5.0007C15.6472 3.9667 13.8948 3.3573 11.9995 3.3573C7.22521 3.3573 3.35632 7.2271 3.35632 12C3.35632 16.774 7.22631 20.6427 11.9995 20.6427C16.7737 20.6427 20.6426 16.7729 20.6426 12C20.6426 11.89 20.6404 11.78 20.6371 11.67L22.8339 10.0838C22.9439 10.7064 23 11.3466 23 12C23 18.0753 18.0751 23 11.9995 23C5.92385 23 1 18.0753 1 12C1 5.9247 5.92495 1 12.0006 1Z",
    fill: "#21A038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9.40476L11.3122 12.4604L20.6176 5L22 7.45629L11.3122 16L7 13.056V9.40476Z",
    fill: "#21A038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSberIcon);
export default __webpack_public_path__ + "static/media/sber-icon.f31485169c061dc30da72925f8648171.svg";
export { ForwardRef as ReactComponent };